import type { MemberIncluded, SelfLimitType } from '@library/types/members';
import {
  getDateTime,
  getFormattedDateTime
} from '@bo-utils/members/memberCommon';
import { DateTime } from 'luxon';
import type { FormattedSelfLimits } from '@library/types/memberResponsibleGaming';

export const getSelfLimits = ({
  memberIncluded,
  selfLimitType
}: {
  memberIncluded: MemberIncluded;
  selfLimitType: SelfLimitType;
}): FormattedSelfLimits | [] => {
  const selfLimit = memberIncluded.find(
    (includedType) => includedType.type === selfLimitType
  );

  if (!selfLimit) {
    return [];
  }

  const isSelfTimeoutType = selfLimitType === 'self_timeout';

  const {
    attributes: {
      end_date: endDateValue,
      updated_at: updatedAt = '',
      time_period_hours: timePeriodHours,
      time_period_months: timePeriodMonths = 0
    }
  } = selfLimit;

  const updatedDateTime = getDateTime({ dateString: updatedAt });

  const { formattedDate: updatedDate, formattedTime: updatedTime } =
    getFormattedDateTime({ dateTime: updatedDateTime });

  if (isSelfTimeoutType) {
    const endDateTime = getDateTime({ dateString: endDateValue });

    const { formattedDate: endDate, formattedTime: endTime } =
      getFormattedDateTime({ dateTime: endDateTime });

    const timePeriodDays = (timePeriodHours || 0) / 24;
    return [
      {
        endDate,
        endTime,
        timeRemaining: `${timePeriodDays} Day${timePeriodDays > 1 ? 's' : ''}`,
        selfLimitType: 'Self Timeout',
        updatedDate,
        updatedTime
      }
    ];
  }

  return [
    {
      endDate: endDateValue
        ? DateTime.fromISO(endDateValue).toFormat('MMMM dd, yyyy')
        : '',
      endTime: '',
      timeRemaining: `${timePeriodMonths} Month${timePeriodMonths || 0 > 1 ? 's' : ''}`,
      selfLimitType: 'Self Exclusion',
      updatedDate,
      updatedTime
    }
  ];
};
